<template>
	<div>
		<v-overlay :value="isLoading">
			<v-progress-circular
				indeterminate
				size="64"
				color="primary"
			></v-progress-circular>
		</v-overlay>
		
		<v-data-table
			:headers="headersToShow"
			:items="contrattiDiServizio"
			:search="search"
			:loading="isLoadingContrattiDiServizio"
			:footer-props="{
				'items-per-page-options': [5, 10, 25, 50, 100, -1]
			}"
			:items-per-page="50"
			height="calc(100vh - 207px)"
			fixed-header
			multi-sort
		>
			<template v-slot:item.importo_acconto="{ item }">
				{{ item.importo_acconto?.replace('.', ',') }}
			</template>
			
			<template v-slot:item.tipo_contratto_di_servizio.is_gold="{ item }">
				{{ item.tipo_contratto_di_servizio === null ? null : (item.tipo_contratto_di_servizio.is_gold ? 'SI' : 'NO') }}
			</template>
			
			<template v-slot:item.importo_saldo="{ item }">
				{{ item.importo_saldo?.replace('.', ',') }}
			</template>
			
			<template v-slot:item.importo_acconto_esiti_definitivi="{ item }">
				{{ item.importo_acconto_esiti_definitivi?.replace('.', ',') }}
			</template>
			
			<template v-slot:item.importo_saldo_esiti_definitivi="{ item }">
				{{ item.importo_saldo_esiti_definitivi?.replace('.', ',') }}
			</template>
			
			<template v-slot:item.importo_totale_bonus_esiti_provvisori="{ item }">
				{{ item.importo_totale_bonus_esiti_provvisori?.replace('.', ',') }}
			</template>
			
			<template v-slot:item.importo_totale_bonus_esiti_definitivi="{ item }">
				{{ item.importo_totale_bonus_esiti_definitivi?.replace('.', ',') }}
			</template>
			
			<template v-slot:item.data_scadenza_saldo="{ item }">
				{{ formatDateToItaly(item.data_scadenza_saldo) }}
			</template>
			
			<template v-slot:item.data_scadenza_saldo_esiti_definitivi="{ item }">
				{{ formatDateToItaly(item.data_scadenza_saldo_esiti_definitivi) }}
			</template>
			
			<template v-slot:item.one_string_tags="{ item }">
				<span
					style="cursor: pointer"
					@click="openTagsDialog(item)"
				>
					{{ item.one_string_tags }}
				</span>
			</template>
			
			<template v-slot:item.notes="{ item }">
				<span
					class="d-inline-block text-truncate"
					style="max-width: 150px; cursor: pointer"
					@click="openContrattoDiServizioNotesDialog(item)"
				>
					{{ item.notes || '------' }}
				</span>
			</template>
			
			<template v-slot:item.account_manager="{ item }">
				{{ item.account_manager?.nome }} {{ item.account_manager?.cognome }}
			</template>
			
			<template v-slot:item.actions="{ item }">
				<v-progress-circular
					v-if="item.downloadingContrattoDiServizio"
					size="20"
					width="3"
					color="secondary"
					class="mr-2"
					indeterminate
				></v-progress-circular>
				<v-hover
					v-else
					v-slot="{ hover }"
				>
					<v-icon
						size="20"
						:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
						@click="download(item, 'contratto_di_servizio')"
					>
						mdi-tray-arrow-down
					</v-icon>
				</v-hover>
				
				<v-hover v-if="isAccountManager" v-slot="{ hover }">
					<v-icon
						size="20"
						:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
						@click="openContrattoDiServizioDialog('edit', item)"
					>
						mdi-pencil
					</v-icon>
				</v-hover>
				
				<v-hover v-if="isAccountManager" v-slot="{ hover }">
					<v-icon
						size="20"
						:class="`mr-2 ${hover ? 'secondary--text' : ''}`"
						@click="openContrattoDiServizioDialog('show', item)"
					>
						mdi-text-box-search-outline
					</v-icon>
				</v-hover>
				
				<v-btn
					color="tertiary"
					@click="openPraticheDataTableDialog(item.id)"
					class="black--text mr-2"
					small
				>
					Pratiche
				</v-btn>
			</template>
			
			<template v-slot:footer.prepend>
				<div class="d-flex align-center">
					<v-btn
						@click="openHideShowHeadersDialog()"
						color="secondary"
						class="ml-md-auto mr-3 white--text"
						depressed
					>
						<template v-if="isCliente">
							Mostra/Nascondi Colonne
						</template>
						<template v-else>
							<v-icon small>mdi-minus</v-icon>
							<v-icon>mdi-view-column-outline</v-icon>
							<v-icon small>mdi-plus</v-icon>
						</template>
					</v-btn>
					
					<v-btn
						color="secondary"
						class="white--text"
						@click="downloadCsvColonneVisibili()"
						:disabled="isLoading"
					>
						Scarica CSV colonne visibili
					</v-btn>
				</div>
			</template>
		</v-data-table>
		
		<v-dialog
			v-model="showPraticheDataTableDialog"
			scrollable
			persistent
		>
			<v-card>
				<v-card-title class="text-h5">
					Pratiche del Contratto di Servizio
				</v-card-title>
				<v-card-text>
					<pratiche
						:key="praticheKey"
						:contratto-di-servizio-id="contrattoId"
						@reload-contratti-di-servizio="reloadContrattiDiServizio()"
					></pratiche>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						class="black--text"
						@click="showPraticheDataTableDialog = false"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		
		<v-dialog
			:value="showContrattoDiServizioDialog"
			persistent
			scrollable
			max-width="1200"
		>
			<store-edit-view-contratto-di-servizio
				:key="contrattoDiServizioKey"
				v-model="contrattoDiServizio"
				:action="action"
				@close="showContrattoDiServizioDialog = false"
				@reload-contratti-di-servizio="reloadContrattiDiServizio()"
			></store-edit-view-contratto-di-servizio>
		</v-dialog>
		
		<v-dialog
			v-model="filtersDialog"
			scrollable
			persistent
			width="800px"
		>
			<contratti-di-servizio-filters
				:key="contrattiDiServizioFiltersKey"
				ref="contrattiDiServizioFilters"
				@close="filtersDialog = false"
				@reload-contratti-di-servizio="reloadContrattiDiServizio()"
			></contratti-di-servizio-filters>
		</v-dialog>
		
		<!-- MOSTRA / NASCONDI COLONNE TABELLA -->
		<v-dialog
			v-model="hideShowHeadersDialog"
			width="unset"
		>
			<v-card>
				<v-card-title>
					<span class="mr-1">Mostra/nascondi colonne</span>
					<v-spacer></v-spacer>
					<v-icon @click="hideShowHeadersDialog = false">mdi-close</v-icon>
				</v-card-title>
				<v-card-text>
					<v-sheet
						outlined
						rounded
						class="py-3"
					>
						<v-treeview
							:items="headersToFilter"
							item-key="value"
							item-text="text"
							v-model="selectedHeaders"
							selected-color="primary"
							selectable
							dense
							open-all
						>
						</v-treeview>
					</v-sheet>
				</v-card-text>
			</v-card>
		</v-dialog>
		
		<v-dialog
			v-model="contrattoDiServizioNotesDialog"
			persistent
			max-width="700"
			scrollable
		>
			<contratto-di-servizio-notes
				:key="contrattoDiServizioNotesKey"
				v-model="contrattoDiServizioForNotes"
				@close="contrattoDiServizioNotesDialog = false"
				@contratto-di-servizio-updated="updateContrattoDiServizioNotesInDataTable($event)"
			></contratto-di-servizio-notes>
		</v-dialog>
		
		<!-- TAGS -->
		<v-dialog
			v-model="tagsDialog"
			persistent
			max-width="700"
			scrollable
		>
			<v-card>
				<v-card-title class="py-2 primary">
					<span class="tertiary--text">Tags Contratto di Servizio</span>
				</v-card-title>
				<v-card-text>
					<store-edit-delete-contratto-di-servizio-tags
						:key="tagsKey"
						:contratto-di-servizio="contrattoDiServizioForTags"
						@is-loading="isLoadingTags = $event"
						@close="tagsDialog = false"
						@tags-updated="updateContrattoDiServizioObject($event)"
					></store-edit-delete-contratto-di-servizio-tags>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="tertiary"
						@click="tagsDialog = false"
						:disabled="isLoadingTags"
						class="black--text"
					>
						Chiudi
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	props: ['search'],
	data() {
		return {
			isLoadingContrattiDiServizio: false,
			isReloadingContrattiDiServizio: false,
			
			
			contrattiDiServizio: [],
			
			contrattiDiServizioFiltersKey: 0,
			filtersDialog: false,
			
			praticheKey: 0,
			showPraticheDataTableDialog: false,
			contrattoId: null,
			
			contrattoDiServizioKey: 0,
			showContrattoDiServizioDialog: false,
			contrattoDiServizio: null,
			action: null,
			
			hideShowHeadersDialog: false,
			selectedHeaders: [],
			
			contrattoDiServizioNotesKey: 0,
			contrattoDiServizioForNotes: null,
			contrattoDiServizioNotesDialog: false,
			
			// tags
			tagsKey: 0,
			contrattoDiServizioForTags: false,
			tagsDialog: null,
			isLoadingTags: false,
			
			updatingContrattoDiServizioObject: false
		}
	},
	
	created() {
		this.getContrattiDiServizio();
		
		// recupero dal localStorage le colonne che si è scelto di mostrare nella tabella
		if (localStorage.getItem('selected_contratti_di_servizio_headers_manager_clickday')) {
			this.selectedHeaders = JSON.parse(localStorage.getItem('selected_contratti_di_servizio_headers_manager_clickday'));
		}
		else {
			this.selectedHeaders = this.headers.map(header => (header.value));
			localStorage.setItem('selected_contratti_di_servizio_headers_manager_clickday', JSON.stringify(this.selectedHeaders));
		}
	},
	
	watch: {
		isLoading(boolean) {
			this.$emit('is-loading', boolean)
		},
		selectedHeaders(newHeaders, oldHeaders) {
			localStorage.setItem('selected_contratti_di_servizio_headers_manager_clickday', JSON.stringify(newHeaders));
		}
	},
	
	computed: {
		...mapGetters({
			appliedFilters: 'contrattiDiServizioFilters/appliedFilters',
			accountManagersIds: 'sharedFilters/accountManagersIds',
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente'
		}),
		computedAccountManagersIds() {
			return this.accountManagersIds.value;
		},
		isLoading() {
			return this.isLoadingContrattiDiServizio
				|| this.updatingContrattoDiServizioObject
				|| this.isReloadingContrattiDiServizio;
		},
		headers() {
			return [
				{ text: 'ID', value: 'id' },
				{ text: 'Codice Cliente', value: 'pratiche[0].accordo.cliente.codice_cliente' },
				{ text: 'Ragione Sociale Cliente', value: 'pratiche[0].accordo.cliente.ragione_sociale' },
				{
					text: 'Nome Cliente',
					value: 'pratiche[0].accordo.cliente.nome' ,
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Cognome Cliente',
					value: 'pratiche[0].accordo.cliente.cognome',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Link Affare',
					value: 'pratiche[0].accordo.link_affare',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Gold',
					value: 'tipo_contratto_di_servizio.is_gold',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Nome Referente',
					value: 'nome_referente_accordo',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Cognome Referente',
					value: 'cognome_referente_accordo',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{ text: 'Ragione Sociale Contratto', value: 'ragione_sociale' },
				{ text: 'Nome Contratto', value: 'nome' },
				{ text: 'Cognome Contratto', value: 'cognome' },
				{
					text: 'PEC Contratto',
					value: 'pec',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Tipo Contratto',
					value: 'tipo_contratto_di_servizio.nome',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Partita IVA Contratto',
					value: 'partita_iva'
				},
				{
					text: 'Codice Fiscale Contratto',
					value: 'codice_fiscale'
				},
				{
					text: 'Indirizzo di fatturazione',
					value: 'indirizzo_fatturazione',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'CAP di fatturazione',
					value: 'cap_fatturazione',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Comune di fatturazione',
					value: 'comune_fatturazione',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Provincia di fatturazione',
					value: 'provincia_fatturazione',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Nazione di fatturazione',
					value: 'nazione_fatturazione',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{ text: 'Codice univoco SDI', value: 'codice_univoco' },
				{ text: 'Email Contratto', value: 'email' },
				{ text: 'Modalità di pagamento', value: 'tipo_contratto_di_servizio.tipo_pagamento' },
				{ text: 'Modalità di erogazione bonus', value: 'tipo_erogazione_bonus' },
				{ text: 'Numero Pratiche', value: 'pratiche_count' },
				{
					text: 'Imponibile Acconto Esiti Provvisori',
					value: 'importo_acconto',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{ text: 'Imponibile Esiti Provvisori', value: 'importo_saldo' },
				{ text: 'Imponibile Totale Bonus Esiti Provvisori', value: 'importo_totale_bonus_esiti_provvisori' },
				{
					text: 'Imponibile Acconto Esiti Definitivi',
					value: 'importo_acconto_esiti_definitivi',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{ text: 'Imponibile Esiti Definitivi', value: 'importo_saldo_esiti_definitivi' },
				{ text: 'Imponibile Totale Bonus Esiti Definitivi', value: 'importo_totale_bonus_esiti_definitivi' },
				{
					// text: 'Data scadenza saldo esiti provvisori',
					text: 'Prima Scadenza Fattura Esiti Provvisori',
					value: 'data_scadenza_saldo',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					// text: 'Data scadenza saldo esiti definitivi',
					text: 'Prima Scadenza Fattura Esiti Definitivi',
					value: 'data_scadenza_saldo_esiti_definitivi',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Tags',
					value: 'one_string_tags',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Note',
					value: 'notes',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				{
					text: 'Account Manager',
					value: 'account_manager',
					class: this.isAccountManager || 'd-none',
					cellClass: this.isAccountManager || 'd-none'
				},
				// questi due sotto servono a far funzionare la ricerca sul nome e il cognome dell'account manager
				{ text: 'Account Manager', value: 'account_manager.nome', class: 'd-none', cellClass: 'd-none' },
				{ text: 'Account Manager', value: 'account_manager.cognome', class: 'd-none', cellClass: 'd-none' },
				{ text: 'Azioni', value: 'actions', width: '230px', sortable: false },
			]
		},
		headersToFilter() {
			let headers = this.isCliente ? this.headers.filter(h => h.class != 'd-none') : this.headers;
			
			return [{
				value: 'headers',
				text: 'Tutte',
				children: headers.flatMap(header => {
					if (header.value !== 'actions'
						&& header.value !== 'account_manager.nome'
						&& header.value !== 'account_manager.cognome'
					) {
						return {
							value: header.value,
							text: header.text
						}
					}
					else return [];
				})
			}]
		},
		headersToShow() {
			return this.headers.filter(header => this.selectedHeaders.includes(header.value) || header.value == 'actions')
		},
		// computedHeaders() {
		// 	if (this.isCliente) return this.headers
		// }
	},
	
	methods: {
		getContrattiDiServizio() {
			this.isLoadingContrattiDiServizio = true;
			return axios.get('/api/contratti-di-servizio', {
				params: {
					filters: this.appliedFilters,
					accountManagersIds: this.computedAccountManagersIds
				}
			})
				.then(response => {
					this.contrattiDiServizio = response.data;
					this.contrattiDiServizio.forEach(contratto => {
						this.$set(contratto, 'downloadingContrattoDiServizio', false);
					})
				})
				.finally(() => {
					this.isLoadingContrattiDiServizio = false;
				})
		},
		openContrattoDiServizioDialog(action, contrattoDiServizio = null) {
			this.contrattoDiServizio = contrattoDiServizio;
			this.action = action;
			this.contrattoDiServizioKey++;
			this.showContrattoDiServizioDialog = true;
		},
		async reloadContrattiDiServizio() {
			this.isReloadingContrattiDiServizio = true;
			await this.getContrattiDiServizio();
			this.isReloadingContrattiDiServizio = false;
		},
		openPraticheDataTableDialog(contrattoId) {
			this.praticheKey++;
			this.contrattoId = contrattoId;
			this.showPraticheDataTableDialog = true;
		},
		download(contrattoDiServizio, key) {
			const fileName = this.getFileNameFromPath(contrattoDiServizio.path_contratto_di_servizio);
			if (key == 'contratto_di_servizio') contrattoDiServizio.downloadingContrattoDiServizio = true;
			axios.post('/api/storage/download',
				{
					path: contrattoDiServizio.path_contratto_di_servizio
				},
				{
					responseType: 'blob'
				})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'contratto_di_servizio') contrattoDiServizio.downloadingContrattoDiServizio = false;
				})
		},
		openContrattiDiServizioFilters() {
			this.filtersDialog = true;
		},
		openHideShowHeadersDialog() {
			this.hideShowHeadersDialog = true;
		},
		openContrattoDiServizioNotesDialog(contrattoDiServizio) {
			this.contrattoDiServizioNotesKey++;
			this.contrattoDiServizioForNotes = contrattoDiServizio;
			this.contrattoDiServizioNotesDialog = true;
		},
		updateContrattoDiServizioNotesInDataTable(data) {
			this.contrattiDiServizio
				.find(contrattoDiServizio => contrattoDiServizio.id == data.contrattoDiServizioUpdated.id)
				.notes = data.contrattoDiServizioUpdated.notes;
		},
		openTagsDialog(contrattoDiServizio) {
			this.tagsKey++;
			this.contrattoDiServizioForTags = contrattoDiServizio;
			this.tagsDialog = true;
		},
		updateContrattoDiServizioObject(data) {
			this.updatingContrattoDiServizioObject = true;
			if (data.callAxios) {
				axios.get(`/api/contratti-di-servizio/${data.contrattoDiServizio.id}`)
					.then(response => {
						Object.assign(this.contrattiDiServizio?.find(contratto => contratto.id == data.contrattoDiServizio.id), response.data);
						this.updatingContrattoDiServizioObject = false;
					})
			}
			// Non utilizzato ma potrebbe servire
			// else {
			// 	Object.assign(this.contrattiDiServizio?.find(contratto => contratto.id == data.contrattoDiServizio.id), data.contrattoDiServizio);
			// 	this.updatingContrattoDiServizioObject = false;
			// }
		},
		downloadCsvColonneVisibili() {
			// 1. Header realmente mostrati in tabella, escluse colonne da ignorare
			const headersCsv = this.headersToShow
				.filter(header => 
					header.value !== 'actions' &&
					header.value !== 'account_manager.nome' &&
					header.value !== 'account_manager.cognome'
				);
			
			// 2. Trasformo ogni riga della tabella in un oggetto pronto per il CSV
			const rows = this.contrattiDiServizio.map(contratto => {
				const row = {};
				headersCsv.forEach(header => {
					// Gestione speciale per Account Manager (combino nome e cognome)
					if (header.value === 'account_manager') {
						const nome = contratto.account_manager?.nome || '';
						const cognome = contratto.account_manager?.cognome || '';
						row[header.text] = `${nome} ${cognome}`.trim();
					}
					// Gestione speciale per Gold (SI/NO)
					else if (header.value === 'tipo_contratto_di_servizio.is_gold') {
						row[header.text] = contratto.tipo_contratto_di_servizio === null ? '' : (contratto.tipo_contratto_di_servizio.is_gold ? 'SI' : 'NO');
					}
					// Gestione date
					else if (header.value === 'data_scadenza_saldo') {
						row[header.text] = this.formatDateToItaly(contratto.data_scadenza_saldo);
					}
					else if (header.value === 'data_scadenza_saldo_esiti_definitivi') {
						row[header.text] = this.formatDateToItaly(contratto.data_scadenza_saldo_esiti_definitivi);
					}
					// Sostituisco il punto con la virgola per i valori numerici in formato stringa
					else if (
						header.value === 'importo_acconto' ||
						header.value === 'importo_saldo' ||
						header.value === 'importo_acconto_esiti_definitivi' ||
						header.value === 'importo_saldo_esiti_definitivi' ||
						header.value === 'importo_totale_bonus_esiti_provvisori' ||
						header.value === 'importo_totale_bonus_esiti_definitivi'
					) {
						row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(contratto, header.value)?.replace('.', ',') || '';
					}
					else {
						row[header.text] = this.ottieniValoreDallOggettoUsandoIlPercorso(contratto, header.value);
					}
				});
				return row;
			});
			
			// 3. Creo il CSV
			let csv = this.$papa.unparse(rows, {
				delimiter: ';',
				header: true,
				columns: headersCsv.map(header => header.text) // ordine colonne = ordine header corrente
			});
			
			// Prepend BOM (risolve problemi di codifica)
			csv = '\uFEFF' + csv;
			
			// 4. Download
			this.$papa.download(csv, 'contratti-di-servizio');
		},
	}
}
</script>

<style scoped>

</style>